var render = function render(){var _vm=this,_c=_vm._self._c;return _c('start-page-template',[_c('reset-password-form',{attrs:{"form-error":_vm.formError,"loading":_vm.isLoading},on:{"submit":_vm.signIn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }